var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-page',[_c('bloc-simple',{staticClass:"flex-shrink-0 mb-3",staticStyle:{"min-width":"350px"}},[_c('left-bar')],1),_c('div',{staticClass:"flex-grow-1"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }